import { Route, RouterOutlet } from "../../core/router";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

const template = `
    <div id="#= data.id #">
    </div>
`;

export type RouterViewOptions = ComponentOptions;

export class RouterView extends TemplateComponent implements RouterOutlet {

    options: RouterViewOptions;
    activeRouteId: number;
    activeComponent: Component;

    constructor(options?: RouterViewOptions) {
        super(template, options || {});
    }

    preRender(): void {
        this.router.registerOutlet(this);
    }

    destroy(): void {
        this.router.unregisterOutlet(this);
    }

    async setRoute(route: Route): Promise<void> {
        if (!route.alwaysReload && this.activeRouteId == route.id) {
            this.activeComponent.onNavigate();
            return;
        }

        let component: Component;
        if (typeof route.component == "string") {
            this.setComponent(route.loading());
            const [moduleName, className] = route.component.split(".");
            const module = await this.router.loadModule(moduleName);
            try {
                component = new module[className]();
            } catch (e) {
                this.activeRouteId = null;
                this.activeComponent && this.activeComponent.destroyComponent();
                this.getContainer().children().remove();
                throw e;
            }
        } else {
            component = route.component();
        }

        this.activeRouteId = route.id;
        this.activeComponent && this.activeComponent.destroyComponent();
        this.getContainer().children().remove();

        this.renderComponent(component);
    }

    setComponent(component: Component | null): void {
        this.activeRouteId = null;
        this.activeComponent && this.activeComponent.destroyComponent();
        this.getContainer().children().remove();

        if (component) {
            this.renderComponent(component);
        }
    }

    private renderComponent(component: Component): void {
        this.activeComponent = component;
        this.activeComponent.router = this.router;
        this.activeComponent.contentRoot = this.contentRoot;
        this.activeComponent.recursiveDisable = this.recursiveDisable;
        this.activeComponent.options.screenEntityType = this.options.screenEntityType;
        this.activeComponent.options.zScreen = this.options.zScreen;
        this.activeComponent.render(this.getContainer());
        this.activeComponent.onNavigate();
    }

}
